import React, { Fragment } from 'react';
import styled, { css, keyframes } from 'styled-components';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { MdArrowForward } from '@react-icons/all-files/md/MdArrowForward';
import { Text, Box, Flex } from './';
import { theme } from '../style';

import Tick from '../assets/images/Tick.svg';
import Cross from '../assets/images/Close.svg';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const Table = styled.table`
  width: 100%;
  margin: 36px 0;
  text-align: center;
  border-collapse: collapse;
  border: 0;
  animation: ${fadeIn} 0.5s ease-in-out;

  th,
  td {
    padding: 6px 10px;
    font-weight: normal;
  }

  ${({ popular }) =>
    popular &&
    css`
      th:nth-child(${popular}),
      td:nth-child(${popular}) {
        background-color: ${theme.colors.grey.v1};
      }

      thead > tr:nth-child(1) > th:nth-child(${popular}) {
        border-radius: 14px 14px 0 0;
      }

      tbody > tr:last-child > td:nth-child(${popular}) {
        border-radius: 0 0 14px 14px;
      }
    `}

  .popular-banner {
    position: absolute;
    border-radius: 14px;
    padding-bottom: 6px;
    color: white;
    background-color: blue;
    top: -52px;
    left: 50%;
    transform: translateX(-50%);
  }
`;

const PricingContainer = styled(Flex)`
  height: 200px;

  .get-started {
    height: 42px;
    margin: 0 14px;
    border-radius: 8px;
    background-color: ${theme.colors.grey.v1};
    color: black;
    text-transform: none;
    font-family: ${theme.fonts.primary};
    font-size: 16px;

    &.popular-button {
      background-color: black;
      color: white;
    }

    @media ${theme.devices.md} {
      display: none;
    }
  }

  .get-started-tablet {
    display: none;
    width: 40px;
    height: 40px;
    background-color: #4a90e2;
    left: 50%;
    transform: translateX(-50%);
    transition: all 0.2s;

    :hover {
      background-color: #1f68c2;
      color: white;
    }

    @media ${theme.devices.md} {
      display: inline-block;
    }
  }
`;

const DummyPadding = () => (
  <tr>
    <td height="30px"></td>
    <td height="30px"></td>
    <td height="30px"></td>
    <td height="30px"></td>
    <td height="30px"></td>
  </tr>
);

const getKey = (keyName, comingSoon) => {
  return (
    <>
      <Text color="grey.v7" textAlign="right">
        {keyName}
      </Text>
      {comingSoon && (
        <Text fontSize={0} color="grey.v4" textAlign="right">
          coming soon
        </Text>
      )}
    </>
  );
};

const getValue = (value) => {
  switch (value) {
    case 'Yes':
      return <img src={Tick} alt="Tick" />;
    case 'No':
      return <img src={Cross} alt="Cross" />;
    default:
      return <Text color="grey.v7">{value}</Text>;
  }
};

const PricePlan = ({ activePlan }) => {
  const { planType, popularPlan, summery, table } = activePlan || {};

  const plans = [
    summery?.plan1,
    summery?.plan2,
    summery?.plan3,
    summery?.plan4,
  ];

  return (
    <Table popular={Number(popularPlan) + 1}>
      <thead>
        <tr>
          <th width="20%">
            <PricingContainer
              flexDirection="column"
              justifyContent="space-between"
            />
          </th>
          {plans.length &&
            plans.map((plan, index) => (
              <th width="20%" key={index}>
                <PricingContainer
                  position="relative"
                  flexDirection="column"
                  justifyContent="space-between"
                  mt={4}
                >
                  {Number(popularPlan) === index + 1 && (
                    <Box className="popular-banner" px={3} py={1}>
                      Popular
                    </Box>
                  )}
                  <Text textAlign="center" color="grey.v4">
                    {plan.planName}
                  </Text>
                  <Flex justifyContent="center">
                    <Text as="h3" color="black" fontWeight="bold">
                      <sup className="currency-sign">{plan.currencySymbol}</sup>
                      {plan.price}
                      <sub className="type">
                        {planType === 'Monthly' ? '/m' : '/y'}
                      </sub>
                    </Text>
                  </Flex>
                  <Button
                    href={plan.link.url}
                    className={`get-started ${
                      Number(popularPlan) === index + 1 && 'popular-button'
                    }`}
                  >
                    {plan.link.title}
                  </Button>
                  <Tooltip title={plan.link.title}>
                    <IconButton className="get-started-tablet">
                      <MdArrowForward />
                    </IconButton>
                  </Tooltip>
                </PricingContainer>
              </th>
            ))}
        </tr>
      </thead>

      <tbody>
        {Array.isArray(table) &&
          table.map((block, index) => (
            <Fragment key={index}>
              <DummyPadding />
              <tr>
                <td height="60px">
                  <Text color="grey.v3" textAlign="right">
                    {block.blockTitle}
                  </Text>
                </td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              {Array.isArray(block?.row) &&
                block.row.map((col, i) => (
                  <tr key={i}>
                    <td height={col.comingSoon ? '60px' : '50px'}>
                      {getKey(col.keyName, col.comingSoon)}
                    </td>
                    <td height="50px">{getValue(col.valuePlan1)}</td>
                    <td height="50px">{getValue(col.valuePlan2)}</td>
                    <td height="50px">{getValue(col.valuePlan3)}</td>
                    <td height="50px">{getValue(col.valuePlan4)}</td>
                  </tr>
                ))}
            </Fragment>
          ))}
        <DummyPadding />
      </tbody>
    </Table>
  );
};

export default PricePlan;
